import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const clearUsersSelection = createAction(types.CLEAR_USERS_SELECTION);
export const toggleUserSelection = createAction(types.TOGGLE_USER_SELECTION);
export const setUsersSelection = createAction(types.SET_USERS_SELECTION);
